import React from "react";
import BoxWrapper from "../../components/ui/BoxWrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatDateString } from "../../helpers/general";
import { format } from "date-fns";
import {
  faClock,
  faLocationDot,
  faMobileScreen,
  faShield,
} from "@fortawesome/free-solid-svg-icons";
import { faAndroid, faApple } from "@fortawesome/free-brands-svg-icons";

interface AppConfigurationProps {
  data: any;
}

export default function AppConfigurationTab({ data }: AppConfigurationProps) {
  return (
    <BoxWrapper>
      <div className="bg-white px-4 rounded-4">
        <section>
          <div className="row ">
            <div className="col-md-12 row">
              {data?.appSetup?.dates?.updatedAt !== undefined && (
                <div className="flex-wrap gap-3 align-items-start pt-4 mb-3">
                  <h5 className="fw-bold text-start">
                    Informations sur l'application
                  </h5>

                  <hr className="mt-1" />

                  <div className="v_app-card-content">
                    {/* Last Update */}
                    <div className="v_app-section">
                      <FontAwesomeIcon icon={faClock} className="v_app-icon" />
                      <div className="v_app-content-wrapper">
                        <h3 className="v_app-label">
                          Dernière mise à jour des informations
                        </h3>
                        <p className="v_app-value">
                          {/* {data?.appSetup?.dates?.updatedAt} */}
                          {formatDateString(
                            data?.appSetup?.dates?.updatedAt,
                          )} -{" "}
                          {data?.appSetup?.dates?.updatedAt
                            ? format(
                                new Date(data?.appSetup?.dates?.updatedAt),
                                "HH:mm",
                              )
                            : ""}
                        </p>
                      </div>
                    </div>

                    {/* Version */}
                    <div className="d-flex gap-3 align-items-center">
                      <div className="v_app-section w-100">
                        <FontAwesomeIcon
                          icon={faMobileScreen}
                          className="v_app-icon"
                        />
                        <div className="v_app-content-wrapper">
                          <h3 className="v_app-label">Version</h3>
                          <p className="v_app-value">
                            {data?.appSetup?.app?.version}
                          </p>
                        </div>
                      </div>
                      <div className="v_app-section w-100">
                        {data?.appSetup?.platform?.os === "ios" && (
                          <FontAwesomeIcon
                            icon={faApple}
                            className="v_app-icon"
                          />
                        )}
                        {data?.appSetup?.platform?.os === "android" && (
                          <FontAwesomeIcon
                            icon={faAndroid}
                            className="v_app-icon"
                          />
                        )}
                        <div className="v_app-content-wrapper">
                          <h3 className="v_app-label">
                            Systéme d'exploitation
                          </h3>
                          <p className="v_app-value">
                            {data?.appSetup?.platform?.os}{" "}
                            {data?.appSetup?.platform?.device?.["OS Version"]}
                            {
                              data?.appSetup?.platform?.device?.[
                                "System Version"
                              ]
                            }
                          </p>
                        </div>
                      </div>
                      <div className="v_app-section w-100">
                        <FontAwesomeIcon
                          icon={faMobileScreen}
                          className="v_app-icon"
                        />
                        <div className="v_app-content-wrapper">
                          <h3 className="v_app-label">Modèle</h3>
                          <p className="v_app-value">
                            {data?.appSetup?.platform?.device?.Brand}{" "}
                            {data?.appSetup?.platform?.device?.Device}
                            {data?.appSetup?.platform?.device?.["Device Name"]}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Permissions */}
                    <div className="v_app-section">
                      <FontAwesomeIcon icon={faShield} className="v_app-icon" />
                      <div>
                        <h3 className="v_app-label">Permissions</h3>
                        <div className="v_app-permissions-grid">
                          <p className="v_app-permission-label">
                            Activity Recognition:
                          </p>
                          <p className="v_app-permission-value">
                            {data?.appSetup?.permissions?.activityRecognition}
                          </p>

                          <p className="v_app-permission-label">
                            Battery Optimizations:
                          </p>
                          <p className="v_app-permission-value">
                            {data?.appSetup?.permissions?.ignoreBatteryOptimizations.toString()}
                          </p>

                          <p className="v_app-permission-label">Location:</p>
                          <p className="v_app-permission-value">
                            {data?.appSetup?.permissions?.location}
                          </p>

                          <p className="v_app-permission-label">
                            Notifications:
                          </p>
                          <p className="v_app-permission-value">
                            {data?.appSetup?.permissions?.notifications}
                          </p>

                          <p className="v_app-permission-label">
                            System Alert Window:
                          </p>
                          <p className="v_app-permission-value">
                            {data?.appSetup?.permissions?.systemAlertWindow?.toString()}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Operating System
                <div className="v_app-section">
                  <FontAwesomeIcon
                    icon={faComputer}
                    className="v_app-icon"
                  />
                  <div className="v_app-content-wrapper">
                    <h3 className="v_app-label">
                      Système d'exploitation
                    </h3>
                    <p className="v_app-value">
                      {`${data?.appSetup?.platform?.os
                        .charAt(0)
                        .toUpperCase()}${data?.appSetup?.platform?.os.slice(
                        1,
                      )}`}
                    </p>
                    <p className="v_app-version-info">
                      Version: {data?.appSetup?.platform?.version}
                    </p>
                  </div>
                </div> */}

                    {/* Location Service */}
                    <div className="v_app-section">
                      <FontAwesomeIcon
                        icon={faLocationDot}
                        className="v_app-icon"
                      />
                      <div className="v_app-content-wrapper">
                        <h3 className="v_app-label">Service de localisation</h3>
                        <p className="v_app-value">
                          {data?.appSetup?.services?.locationServiceEnabled
                            ? "Activé"
                            : "Désactivé"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {data?.appSetup?.dates?.updatedAt === undefined && (
                <div className="v_app-label flex justify-center items-center">
                  <h2>Aucune information</h2>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </BoxWrapper>
  );
}
